<template>
  <div class="page">
    <div class="login-wrap" @click="handleLogin">
      <div class="item-desc">
        <img class="icon" src="../assets/images/logo.png" alt="logo" />
        <div style="flex: 1">
          <div class="text">{{ token ? userInfo.realname : "登录" }}</div>
          <div class="point-wrap" v-if="integralPermission == 'Y' && token">
            <div class="num">积分：{{ userPoint }}</div>
            <div
              @click="handleSign"
              class="btn-sign"
              v-if="signInStatus == 'N'"
            >
              每日签到
            </div>
            <div class="btn-signed" v-else>已签到</div>
          </div>
        </div>
      </div>
      <van-icon v-show="!token" class="arrow" name="arrow" />
    </div>
    <div
      class="sx-item"
      @click="handleWxBindOrUnBind"
      v-show="token && isWxAuth === 'Y'"
    >
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-wx.png" alt="微信" />
        <div class="text" v-show="bind === 'N'">绑定微信帐号</div>
        <div class="text" v-show="bind === 'Y'">解除微信帐号绑定</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div class="sx-item" @click="handleRouterFollow" v-show="isWxAuth === 'Y'">
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-fwh.png" alt="微信" />
        <div class="text">关注/取关服务号</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div class="gap"></div>
    <div
      class="sx-item"
      @click="hanldeShouldLoginRouter(false, '/myAlephBook')"
    >
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-book.png" alt="图书" />
        <div class="text">图书借阅/预约</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div class="sx-item" @click="hanldeShouldLoginRouter(false, '/myActivity')">
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-hd.png" alt="活动" />
        <div class="text">活动收藏/预约</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div
      class="sx-item"
      @click="hanldeShouldLoginRouter(false, '/scienceAchieve')"
    >
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-xs.png" alt="学术成果" />
        <div class="text">我的学术成果</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div
      class="sx-item"
      @click="
        hanldeShouldLoginRouter(true, {
          id: thirdAppJcsId,
          url: thirdAppJcsUrl,
          name: '我的课程',
          path: 'person',
        })
      "
    >
      <div class="item-desc">
        <img class="icon" src="../assets/images/icon-kc.png" alt="我的课程" />
        <div class="text">我的课程</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div
      class="sx-item"
      @click="hanldeShouldLoginRouter(false, '/bookdonation')"
    >
      <div class="item-desc">
        <img
          class="icon"
          src="../assets/images/icon-donate.png"
          alt="捐赠列表"
        />
        <div class="text">我的捐赠</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div
      class="sx-item"
      v-if="integralPermission == 'Y'"
      @click="hanldeShouldLoginRouter(false, '/integral')"
    >
      <div class="item-desc">
        <img
          class="icon"
          src="../assets/images/icon-jifen.png"
          alt="我的积分"
        />
        <div class="text">我的积分</div>
      </div>
      <van-icon class="arrow" name="arrow" />
    </div>
    <div class="logout-wrap" v-show="token">
      <div class="logout-item" @click="handleSwitchAccount">切换帐号</div>
      <div class="gap"></div>
      <div class="logout-item" @click="handleLogout">退出登录</div>
      <div class="gap"></div>
    </div>
    <iframe
      ref="iframe"
      v-show="false"
      :src="logoutUrl"
      frameborder="0"
    ></iframe>
    <m-tab-bar active-index="1"></m-tab-bar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import MTabBar from "@/components/MTabBar";
import {
  UIS_AUTH_URL,
  STATUS_CODE_OK,
  TOAST_STAY_TIME,
  UIS_LOGOUT_URL,
} from "@/config";
import {
  userAuth,
  weChatBind,
  logout,
  integralPermissionCheck,
} from "@/api/common";
import { userPointSignGet, userSignin } from "@/api/integral";
import { hasLoginCheck, queryStringParameter, logTrace } from "@/utils";
export default {
  name: "User",
  computed: {
    ...mapGetters(["token", "userInfo", "openId", "bind"]),
  },
  data() {
    return {
      integralPermission: "Y",
      userPoint: 0, // 用户积分
      signInStatus: "Y", // 签到状态
      logoutUrl: "",
      isSwitch: false, // 是否是切换帐号
      isWxAuth: process.env.VUE_APP_IS_WXAUTH, // 是否走了微信授权
      thirdAppJcsId: process.env.VUE_APP_THIRD_APP_JCS_ID, // 第三方应用教参书的id
      thirdAppJcsUrl: process.env.VUE_APP_THIRD_APP_JCS_URL, // 第三方应用教参书跳转的url
    };
  },
  watch: {
    token(val) {
      if (val) {
        this.handleUserPointGet();
        this.handleIntegralPermissionCheck();
      }
    },
  },
  created() {
    this.handleUserPointGet();
    this.handleIntegralPermissionCheck();
  },
  mounted() {
    this.$refs.iframe.addEventListener("load", this.handleIframeOnLoad);
  },
  methods: {
    // 用户是否有积分查看权限
    async handleIntegralPermissionCheck() {
      if (this.token) {
        const { data } = await integralPermissionCheck();
        if (data.code === STATUS_CODE_OK) {
          this.integralPermission = data.data || "N";
        }
      }
    },

    // 用户积分获取
    async handleUserPointGet() {
      if (this.token) {
        const { data } = await userPointSignGet();
        if (data.code === STATUS_CODE_OK) {
          this.userPoint = data.data.userPoint;
          this.signInStatus = data.data.signInStatus;
        }
      }
    },
    // 每日签到
    async handleSign() {
      const { data } = await userSignin();
      if (data.code === STATUS_CODE_OK) {
        this.$notify({
          type: "success",
          message: "签到成功",
          duration: TOAST_STAY_TIME,
        });
        this.handleUserPointGet();
      }
    },
    handleIframeOnLoad() {
      const that = this;
      if (that.logoutUrl) {
        that.setLogout();
        if (that.isSwitch) {
          if (process.env.VUE_APP_IS_WXAUTH === "Y") {
            window.location.replace(
              `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
                that.$route.fullPath
              )}&openId=${that.openId}`
            );
          } else {
            window.location.replace(
              `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
                that.$route.fullPath
              )}`
            );
          }
        } else {
          that.$notify({
            type: "success",
            message: "退出成功",
            duration: TOAST_STAY_TIME,
          });
          that.$router.replace({
            path: "/",
          });
        }
      }
    },
    // 跳转需要登录的路由
    hanldeShouldLoginRouter(isOutUrl = false, param) {
      const that = this;
      hasLoginCheck({
        tip: "请先登录",
        path: that.$route.fullPath,
        callBack: async () => {
          if (isOutUrl) {
            // 用户已经登录，则调用接口获取authCode
            let { data } = await userAuth({
              id: param.id,
            });
            if (data.code === STATUS_CODE_OK) {
              logTrace({
                prefixUrl: that.$route.path,
                prefixUrlName: that.$route.meta.name,
                requestUrl: param.url,
                rquestUrlName: param.name,
                actionType: "page",
                actionTypeCode: "1",
                actionTypeDesc: "页面跳转",
              });
              if (param.path) {
                param.url = queryStringParameter(param.url, "path", param.path);
              }
              // 跳转到第三方应用
              window.location.href = queryStringParameter(
                param.url,
                "authCode",
                data.data.authCode
              );
            }
          } else {
            that.$router.push({
              path: param,
            });
          }
        },
      });
    },
    // 登录
    handleLogin() {
      if (!this.token) {
        const that = this;
        that.setLogout();
        if (process.env.VUE_APP_IS_WXAUTH === "Y") {
          window.location.replace(
            `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
              that.$route.fullPath
            )}&openId=${that.openId}`
          );
        } else {
          window.location.replace(
            `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
              that.$route.fullPath
            )}`
          );
        }
      }
    },
    // 微信绑定或解除绑定
    async handleWxBindOrUnBind() {
      const that = this;
      let bind = "N";
      let msg = "是否解除绑定当前微信帐号";
      let confirmButtonText = "解除绑定";
      if (that.bind === "Y") {
        bind = "N";
        msg = "是否解除绑定当前微信帐号";
        confirmButtonText = "解除绑定";
      } else {
        bind = "Y";
        msg = "是否绑定当前微信帐号";
        confirmButtonText = "绑定";
      }
      try {
        await that.$dialog.confirm({
          title: "提示",
          message: msg,
          confirmButtonText: confirmButtonText,
          cancelButtonText: "关闭",
          confirmButtonColor: "#1989fa",
        });
        let { data } = await weChatBind({
          openId: that.openId,
          bindFlag: bind,
        });
        if (data.code === STATUS_CODE_OK) {
          that.setBind(bind);
          that.$notify({
            type: "success",
            message: "操作成功",
            duration: TOAST_STAY_TIME,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 退出登录
    async handleLogout() {
      const that = this;
      try {
        await that.$dialog.confirm({
          title: "提示",
          message: "确认需要退出吗",
          confirmButtonText: "退出",
          cancelButtonText: "关闭",
          confirmButtonColor: "#1989fa",
        });
        that.isSwitch = false;
        let { data } = await logout();
        if (data.code === STATUS_CODE_OK) {
          that.setLogout();
          that.logoutUrl = UIS_LOGOUT_URL;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 切换帐号
    async handleSwitchAccount() {
      const that = this;
      if (that.bind === "Y") {
        try {
          await that.$dialog.confirm({
            title: "提示",
            message: "切换帐号会与当前微信帐号解除绑定",
            confirmButtonText: "解除绑定",
            cancelButtonText: "关闭",
            confirmButtonColor: "#1989fa",
          });
          let { data } = await weChatBind({
            openId: that.openId,
            bindFlag: "N",
          });
          if (data.code === STATUS_CODE_OK) {
            that.isSwitch = true;
            that.setBind("N");
            let { data: logOutData } = await logout();
            if (logOutData.code === STATUS_CODE_OK) {
              that.setLogout();
              that.logoutUrl = UIS_LOGOUT_URL;
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          await that.$dialog.confirm({
            title: "提示",
            message: "确认切换帐号吗",
            confirmButtonText: "切换",
            cancelButtonText: "关闭",
            confirmButtonColor: "#1989fa",
          });
          that.isSwitch = true;
          let { data } = await logout();
          if (data.code === STATUS_CODE_OK) {
            that.setLogout();
            that.logoutUrl = UIS_LOGOUT_URL;
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    // 跳转到关注引导页
    handleRouterFollow() {
      this.$router.push("/wx-follow");
    },
    ...mapActions(["setLogout", "setBind"]),
  },
  beforeDestroy() {
    this.$refs.iframe.removeEventListener("load", this.handleIframeOnLoad);
  },
  components: {
    MTabBar,
  },
};
</script>

<style scoped lang="scss">
.page {
  padding-bottom: 80px;
  background-color: #f7f8fa;

  .login-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
    background-color: #fff;

    .item-desc {
      display: flex;
      align-items: center;
      flex: 1;

      .icon {
        margin-right: 12px;
        height: 50px;
      }

      .point-wrap {
        margin-top: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .num {
          font-size: 16px;
          color: #666;
        }

        .btn-sign {
          cursor: pointer;
          font-size: 12px;
          padding: 2px 8px;
          color: #fff;
          background-color: #ec6e47;
          border-radius: 20px;
        }

        .btn-signed {
          cursor: pointer;
          font-size: 12px;
          padding: 2px 8px;
          color: #fff;
          background-color: #aaa;
          border-radius: 20px;
        }
      }
    }

    .text {
      font-size: 18px;
      flex: 1;
    }
  }

  .sx-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
    background-color: #fff;

    .item-desc {
      display: flex;
      align-items: center;
      flex: 1;

      .icon {
        margin-right: 8px;
        height: 24px;
      }

      .text {
        flex: 1;

        &.other {
          flex: none;
        }
      }

      .kong {
        flex: 1;
        height: 20px;
      }
    }
  }

  .gap {
    height: 10px;
  }

  .logout-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 80px;

    .logout-item {
      display: flex;
      align-items: center;
      background-color: #fff;
      justify-content: center;
      padding: 8px 0;
      font-size: 16px;
    }
  }
}
</style>
